import { ReactSession } from '../utils/ReactSession.jsx';
import {Navigate} from "react-router-dom";
import {AES, enc} from "crypto-js";
import Navigation from "./Navigation.jsx";
import ProfileContent from "./ProfileContent.jsx";
import LegacyProfileContent from "./LegacyProfileContent.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import MyProfilePage from '../pages/account/my-profile/MyProfilePage.jsx';

function Profile(props) {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let dData, bData, profileContent;
    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (isV2) {
        profileContent = <MyProfilePage />;
    } else if (dData.migrated){
        profileContent = <ProfileContent />;
    }else{
        profileContent = <LegacyProfileContent />;
    }

    return (compareRole("", dData?.userrole || iAmHigherAuthority(0, dData?.role_weight))) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {profileContent}
        </>
    ) : <Navigate to={"/"}/>;
}

export default Profile;